import { ActiveObject, resolve } from '../Container';
import { EditorModeInfo } from './EditorModeInfo';
import { EditorSession } from './EditorSession';
import { MyRoleInfo } from './MyRoleInfo';
import { VolumeSettingsWidget } from './VolumeSettingsWidget';
import { WidgetManager } from './workspace/widgets/WidgetManager';

export class VolumeMechanics extends ActiveObject {

    @resolve(EditorSession) private session!: EditorSession;
    @resolve(WidgetManager) private widgets!: WidgetManager;

    public start() {
        this.burden(
            this.session.observe(EditorModeInfo, this.realizeWidgetIfApplicable),
            this.session.observe(MyRoleInfo, this.realizeWidgetIfApplicable),
        );
        this.realizeWidgetIfApplicable();
    }

    private realizeWidgetIfApplicable = () => {

        this.widgets.delete('volume');

        const dock = this.widgets.createContainer();
        dock.name = 'volume';
        dock.weight = 400;
        dock.style = 'floatWithLines';
        dock.position = ['docked', 'bottomLeft', 'inline'];

        dock.add(this.widgets.createPopout({
            image: 'deqo://icons/hero/volume-up',
            text: 'Volume Settings',
            ui: VolumeSettingsWidget
        }));

        this.widgets.add(dock);
    };
}
